import { TDistrictDepoMapping } from '../utils/types/common';
import {
  ProductCategory,
  TBrand,
  TDepots,
  TEnterprise,
  TGeography,
  TPlant,
  TProductName,
  TProductWithMATNR,
  TRegions,
  TStates,
  GeneralObject,
  Country,
} from '../../src/utils/types';
import { emptySplitApi } from './emptySplitApi';

export const commonService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEnterprise: builder.query<
      TEnterprise[],
      number[]
    >({
      query: (countryIds) => ({
        method: 'GET',
        url: `enterprises/country/${countryIds}`,
      }),
    }),
    getAllStates: builder.query<TGeography[], void>({
      query: () => ({
        method: 'GET',
        url: 'geographies/geoTypeId/2',
      }),
    }),
    getAllDistricts: builder.query<
      TGeography[],
      number | string
    >({
      query: (parentId) => ({
        method: 'GET',
        url: `geographies/parentId/${parentId}`,
      }),
    }),
    getAllTehsil: builder.query<
      TGeography[],
      number | string
    >({
      query: (parentId) => ({
        method: 'GET',
        url: `geographies/parentId/${parentId}`,
      }),
    }),
    getAllVillages: builder.query<
      TGeography[],
      number | string
    >({
      query: (parentId) => ({
        method: 'GET',
        url: `geographies/parentId/${parentId}`,
      }),
    }),
    getRegions: builder.query<TRegions[], void>({
      query: () => ({
        method: 'GET',
        url: 'regions',
      }),
    }),
    getWarehouseModels: builder.query<TRegions[], void>({
      query: () => ({
        method: 'GET',
        url: 'warehouseModels',
      }),
    }),

    getStates: builder.query<TStates[], void>({
      query: () => ({
        method: 'GET',
        url: 'states',
      }),
    }),
    getDepotsByEnterpriseId: builder.query<
      TDepots[],
      number
    >({
      query: (companyId) => ({
        method: 'GET',
        url: `plants/enterprise/${companyId}`,
      }),
    }),
    getAllPlants: builder.query<TPlant[], void>({
      query: () => ({
        method: 'GET',
        url: 'plants',
      }),
    }),
    getDepotsByEnterprises: builder.query<
      TDepots[],
      number[]
    >({
      query: (data) => ({
        method: 'POST',
        url: `plants/enterprise`,
        data,
      }),
    }),
    getAllPlantsByEnterpriseList: builder.query<
      TPlant[],
      number[]
    >({
      query: (data) => {
        return {
          url: 'plants/enterprise',
          method: 'POST',
          data,
        };
      },
    }),
    getProductNamesByEnterprise: builder.query<
      TProductName[],
      number
    >({
      query: (id) => ({
        method: 'GET',
        url: `products/active/${id}/names`,
      }),
    }),
    getAllProductBrands: builder.query<TBrand[], void>({
      query: () => ({
        url: 'brand/all',
        method: 'GET',
      }),
    }),
    getEnterpriseByName: builder.query<TEnterprise, string>(
      {
        query: (data) => ({
          method: 'GET',
          url: `enterprise/search/${data}`,
        }),
      }
    ),
    getEnterpriseById: builder.query({
      query: (data) => ({
        method: 'GET',
        url: `enterprises/${data}`,
      }),
    }),
    getProductMATNRListByEnterprise: builder.query<
      TProductWithMATNR[],
      number
    >({
      query: (id) => ({
        method: 'GET',
        url: `products/matnr/${id}`,
      }),
    }),
    getBrandList: builder.query<GeneralObject[], number>({
      query: (enterpriseId) => ({
        method: 'GET',
        url: `material-groups/enterprise/${enterpriseId}`,
      }),
    }),
    getProductListByEnterpriseId: builder.query<
      GeneralObject[],
      number
    >({
      query: (enterpriseId) => ({
        method: 'GET',
        url: `products/matnr/${enterpriseId}`,
      }),
    }),
    getProductCategories: builder.query<
      ProductCategory[],
      void
    >({
      query: () => ({
        url: 'product-categories',
        method: 'GET',
      }),
    }),
    getAllCountries: builder.query<Country[], void>({
      query: () => ({
        url: 'countries',
        method: 'GET',
      }),
    }),
    getDistrictDepoMappingList: builder.query<
      TDistrictDepoMapping[],
      void
    >({
      query: () => ({
        url: 'retailers/orders/allDistricts',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAllEnterpriseQuery,
  useGetAllStatesQuery,
  useLazyGetAllStatesQuery,
  useGetAllDistrictsQuery,
  useLazyGetAllDistrictsQuery,
  useGetAllTehsilQuery,
  useLazyGetAllTehsilQuery,
  useGetAllVillagesQuery,
  useLazyGetAllVillagesQuery,
  useGetRegionsQuery,
  useGetWarehouseModelsQuery,
  useGetStatesQuery,
  useGetDepotsByEnterpriseIdQuery,
  useLazyGetDepotsByEnterpriseIdQuery,
  useGetAllPlantsQuery,
  useGetDepotsByEnterprisesQuery,
  useGetAllPlantsByEnterpriseListQuery,
  useLazyGetAllPlantsByEnterpriseListQuery,
  useGetProductNamesByEnterpriseQuery,
  useGetAllProductBrandsQuery,
  useGetEnterpriseByNameQuery,
  useGetEnterpriseByIdQuery,
  useGetProductMATNRListByEnterpriseQuery,
  useGetBrandListQuery,
  useGetProductListByEnterpriseIdQuery,
  useLazyGetProductListByEnterpriseIdQuery,
  useLazyGetBrandListQuery,
  useGetProductCategoriesQuery,
  useGetAllCountriesQuery,
  useGetDistrictDepoMappingListQuery,
} = commonService;
